import * as React from "react";
import { Box, Container } from "@mui/material";
import { heroBackgroundSx } from "../tickitMarketingTheme";
import MarketingFormCard from "./MarketingFormCard";

/** Full-page shell for marketing forms (matches /events/request). */
export default function MarketingFormPage({
  title,
  subtitle,
  children,
  loading = false,
  maxWidth = "md",
  id = "main-content",
  footer,
  logoHeight,
  sx = {},
}) {
  return (
    <Box
      component="main"
      id={id}
      sx={{
        ...heroBackgroundSx,
        minHeight: "100%",
        pb: { xs: 6, md: 10 },
        ...sx,
      }}
    >
      <Container maxWidth={maxWidth} sx={{ pt: { xs: 3, md: 5 }, position: "relative", zIndex: 1 }}>
        <MarketingFormCard
          title={title}
          subtitle={subtitle}
          loading={loading}
          footer={footer}
          logoHeight={logoHeight}
        >
          {children}
        </MarketingFormCard>
      </Container>
    </Box>
  );
}
